import styled from 'styled-components';

export const Center = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  min-height: 100dvh;
  max-width: 968px;

  @media only screen and (max-width: 980px) {
    background: #fff;
  }

  @media only screen and (min-width: 1768px) {
    max-width: 1280px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  background: #fff;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  box-shadow: 0px 0px 4px rgba(79, 79, 80, 0.15);
  display: grid;
  grid-template-rows: minmax(0,1fr) auto;
  margin: 1.5rem;
  margin-bottom: 0;

  @media only screen and (max-width: 980px) {
    border-radius: 0;
    box-shadow: none;
    height: 100%;
    margin: 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 564px;

  @media only screen and (min-width: 1680px) {
    min-height: 768px;
  }

  .container-form{
      display: flex;
      place-items: center;
      justify-content: center;
  }

  .box-form{
    width: 100%;
    max-width: 490px;
    animation: fadein 1s;
    margin: 40px 0;

    form {
      button {
        cursor: pointer;
        width: 100%;
      }

      .busca-correios {
        font-size: 14px;
      }
    }
  }

  .box-info{
    width: 100%;
    margin-bottom: 30px;
  }

  .logo-correios {
      width: 200px;
      height: 70px;
      margin-bottom: 18px;

      @media (max-width: 340px) {
        width: 160px;
        height: 40px;
      }
    }

  h1{
      color: #0587FF;
      font-size: 20px;
      margin: 0;
      margin-bottom: 5px;
  }

  p{
      font-size: 14px;
      color: #989898;
      margin: 0;
  }

  .button-correios {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin: 0 auto;
    padding: 12px 18px;
    background: #FFFFFF;
    border-radius: 8px;
    font-size: 14px;
    color: #0587FF;
    border: none;
    text-decoration: none;
    cursor: pointer;
    
    transition: box-shadow 0.2s linear;

    &:hover {
      box-shadow: 0px 4px 24px rgba(18, 45, 71, 0.1);
    }
  }

  form{
    margin-bottom: 16px;

    .form-group{
        position: relative;
        height: 76px;
    }

    input{
        width: 100%;
        background: #F2F2F2;
        height: 48px;
        padding: 10px 25px;
        border-radius: 8px;
        border: none;
        color: #000000;
        text-align: center;
        letter-spacing: 0.3px;

        &:focus{
            outline: 1px solid #737373;
        }

        ~span{
            font-size: 12px;
            color: red;
            display: block;
            margin-top: 10px;
        }
    }

    button {
      width: 205px;
      height: 52px;
      background: #0587FF;
      color: #ffffff;
      font-size: 14px;
      border-radius: 8px;
      text-transform: capitalize;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 16px;
      border: none;

      transition: background 0.2s linear;
  
      &:hover{
         background: #0171d9;
      }
    }
  }

    @keyframes fadein {
        from { opacity: 0; }
        to   { opacity: 1; }
    }

  .container-frame{
      padding: 0;
      flex: 1;
      animation: fadein 1s;
      display: flex;
      flex-direction: column;

      @media only screen and (max-width: 980px) {
        border-radius: 0;
        border: none;
      }

      .header-frame{
        width: 100%;
        display: flex;
        align-items: center;
        gap: 1rem;
        border-bottom: 1px solid #F2F2F2;
        padding:1rem;

        @media only screen and (max-width: 980px) {
            width: 100%;
            margin: 0;
          }
      }

      .frame-item-transportadora {
        flex: 1;
        justify-content: center;
      }

      .content-frame {
        padding: 1.5rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
        &:has(.empty-state-sem-ocorrencias) {
          justify-content: center;
        }

        &:not([data-possui-mapa="true"]) {
          .prazo-entrega {
            padding-inline: 1.5rem;
          }
        }

        .prazo-entrega {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          width: 100%;
          color: #737373;
        }
      }

      .nome-loja {
        margin-block: 1rem;
      }


        .empty-state-sem-ocorrencias {
          margin: 0 auto;
          display: flex;
          align-items: center;
          flex-direction: column;
          gap: 8px;

          > h3 {
            font-size: 36px;
            margin-block: 0;
            color: #383C42;
          }
          > p {
            text-align: center;
            max-width: 75%;
            font-size: 1rem;
            color: #989898;
          }

          > button {
            padding: 8px 16px;
            border-radius: 4px;
            background-color: #0587FF;
            border: none;
            color: #FFFFFF;
            &:hover {
              background-color: #0171d9;
            }
          }
        }

      .frame-container-delivery-info {
        width: 100%;
        display: grid;
        grid-template-columns: minmax(auto,1fr) minmax(auto,1fr);
        justify-items: center;
        justify-content: center;
        gap: 1rem;
        padding-inline: 1.5rem;

        & > :only-child {
          grid-column: 1 / -1;
        }

        &[data-possui-mapa="true"] {
          margin-top: -48px;
        }

        @media only screen and (max-width: 980px) {
          grid-template-columns: minmax(0,1fr);
        }

          > .delivery-info-ocorrencias, 
          > .delivery-info-volumes {
            width: 100%;
            height: fit-content;
            align-items: start;
            > * {
             width: 100%; 
            }
            > h4 {
              padding-left: 1.5rem;
              font-weight: bold;
              text-align: left;

              > sup {
                color: #0171d9;
              }
            }
          }

          > .delivery-info-volumes {
            > a {
                text-decoration: none;
                display: flex;

                > div {
                  min-height: unset;
                  padding: 0.75rem;
                }

                .title {
                  text-align: start;
                  width: 80%;

                  span {
                    color: #A9B8C7;
                    font-size: 12px;
                  }

                  p {
                    color: #383C42;
                    font-size: 14px;
                  }
                }

                .rastrear {
                  color: #0071DB;
                  display: flex;
                  align-items: center;
                  font-size: 0.9rem;
                }
              }
            }
          }
      }

      .map {
        overflow: hidden;
        border-radius: 8px;
        width: 100%;
      }

      .frame-item-info {
          display: flex;
          width: 100%;
          align-items: center;
          gap: 0.5rem;

          > .txt-info {
            display: flex;
            flex-direction: column;
            text-align: left;

            > .txt-title{
              font-size: 16px;
              color: #737373;

              @media only screen and (max-width: 980px) {
                font-size: 10px;
              }
            } 

            > .txt-name{
                font-size: 14px;
                color: #0587FF;
                font-weight: bold;
            }
          }
      }

      .header-action-button {
        display: flex;
        align-items: center;
        gap: 6px;
        width: fit-content;
        background: none;
        border: none;
        outline: none;
        color: #989898;
        font-size: 12px;
        white-space: nowrap;
        padding: 0;

        &:hover {
          color: #0171d9
        }
      }

      button {
        display: flex;
        justify-content: flex-start;

        @media only screen and (max-width: 980px) {
            min-width: auto;
        }

        .material-icons{
            font-size: 20px;
            color: #989898;
            margin: 0 2px;
        }

        .txt {
            font-size: 12px;
            color: #989898;
            text-transform: capitalize;
            display: flex;
            padding: 2px 5px 0;

            @media only screen and (max-width: 980px) {
                padding: 0;
                font-size: 11px;
            }
        }

        &:hover {
            background: none;

            .material-icons, .txt{
                color: #0587FF;
            }
        }
      }
      
      .rastreios {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;

        > div {
          min-width: 80%;
          margin-top: 0;
          box-shadow: none;
          border: 1px solid #E8EAED;

            @media only screen and (max-width: 980px) {
              min-width: 100%;
            }
        }

      iframe{
          padding: 0 10px;
          margin: 10px 0;
          border: none;
      }
    }
`;

export const ContainerCorreios = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 650px;
`

export const CodigoRastreioContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 38px;
  background: #F0F8FF;
  border-top: 1px solid #DDEFFF;
`

export const CodigoRastreio = styled.span`
  font-size: 12px;
  color: #004482;

  font-weight: ${({ weight }) =>
    weight === 'bold' ? 700 : 400}
`

export const MapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  z-index: 1;
`

export const Map = styled.img`
  object-fit: cover;
`;

export const DeliveryStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  background-color: #FFFFFF;
  border: 1px solid #F0F8FF;
  border-radius: 16px;
  box-shadow: 0px 8px 12px #122d4710;
  z-index: 2;
`

export const DeliveryState = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  width: 100%;
  gap: 16px;
  min-height: 79px;
  border-bottom: 1px solid #F2F2F2;

  @media (max-width: 550px) {
    height: max-content;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  transition: background-color 0.2s linear;

  &:hover {
    background-color: #F0F8FF;
  }
`

export const DeliveryStateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;

  &.centralizado {
    & > * {
      justify-content: center;
    }
  }

  @media (max-width: 550px) {
    flex-direction: column;
  }
`

export const DeliveryStateInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12px;
  text-align: start;

  @media (max-width: 550px) {
    text-align: center;
  }
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: flex-start;
  height: 100%;

  width: ${({ type }) =>
    type === 'min' ? '128px' : '220px'};
  height: ${({ type }) =>
    type === 'min' && '42px'
  };

  @media (max-width: 550px) {
    align-items: center;
    width: 100%;
    height: max-content;
  }
`

export const Title = styled.span`
  color: #224261;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  > small {
    font-size: 12px;
    color: #888888;
    font-weight: normal;
    text-transform: lowercase;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  @media (max-width: 550px) {
    -webkit-line-clamp: initial;
    max-height: fit-content;
    margin: 8px 0;
    font-size: 13px;
    text-align: center;
  }
`

export const Icon = styled.img`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin-right: ${({ mr }) => mr};
`

export const Date = styled.span`
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #435F7A;
`

export const Localization = styled.span`
    display: flex;
    font-size: 12px;
    color: #A9B8C7;
    margin-top: 6px;
`

export const LocalizationCity = styled.span`
    display: -webkit-box;
    max-height: 17px;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: 3px;
    text-align: left;
    font-size: 12px;
    color: #224261;
`

export const ButtonSC = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    width: 330px;
    height: 33px;
    background-color: #0587FF;
    font-size: 14px;
    color: #FFFFFF;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    transition: background-color 0.2s linear;

    &:hover {
        background-color: #0580E0;
    }
`

export const HaulerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const HaulerText = styled.span`
    margin: 16px 0 8px;
    font-size: 11px;
    color: #737373;
`

export const HaulerImg = styled.img`
    max-width: 130px;
    height: auto;
    margin-bottom: 16px;
`

export const CorreiosSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 27px 24px;
    margin-top: 64px;
    width: 100%;
    max-width: 490px;
    min-height: 146px;
    background: linear-gradient(271.07deg, #EEBB02 10.4%, #FDCC27 77.15%);
    box-shadow: 0px 2px 12px rgba(18, 45, 71, 0.1);
    border-radius: 8px;

    @media (max-width: 410px) {
        flex-direction: column;
    }
`

export const CorreiosContentImg = styled.img`
    max-width: 117px;
    max-height: 106px;
    margin-right: 16px;

    @media (max-width: 410px) {
        margin: 0 0 12px;
    }
`

export const CorreiosContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: 410px) {
        align-items: center;
    }
`

export const CorreiosContentTitle = styled.h2`
    font-weight: 700;
    font-size: 18px;
    color: #064E97;
    margin: 0;
`

export const CorreiosContentSubtitle = styled.span`
    margin-bottom: 10px;
    font-size: 12px;
    color: #064E97; 
`

export const CorreiosRedirectButton = styled.button`
    position: relative;
    width: 148px;
    height: 36px;
    padding: 10px 24px;
    border-radius: 8px;
    border: none;
    text-align: center;
    font-size: 14px;
    color: #064E97; 
    background: #FFFFFF; 
    cursor: pointer;

    transition: background-color 0.2s linear, color 0.2s linear;

    &:hover {
        color: #FFFFFF;
        background-color: #064E97;
    }
`

export const ChevronRightIcon = styled.img`
    position: absolute;
    width: 16px;
    height: 16px;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
`